/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { RequestValueKeys } from '@medflex/shared-types';
import InquiryValue from './InquiryValue';
import { InquiryPropType } from './PropTypes';

const INQUIRY_VALUE_ORDER = [
  RequestValueKeys.REPRESENTED_PERSON,
  RequestValueKeys.PATIENT_INSURANCE_TYPE_OR_MEDFLEX,
  RequestValueKeys.APPOINTMENT_ACTION,
  RequestValueKeys.APPOINTMENT_REASON,
  RequestValueKeys.APPOINTMENT_TYPE,
  RequestValueKeys.SYMPTOM_DESCRIPTION,
  RequestValueKeys.SYMPTOM_DURATION,
  RequestValueKeys.EXISTING_APPOINTMENT_DATE_TIME,
  RequestValueKeys.APPOINTMENT_DATE_TYPE,
  RequestValueKeys.APPOINTMENT_AVAILABILITY,
  RequestValueKeys.DIAGNOSIS_DETAILS,
  RequestValueKeys.DIAGNOSIS_REQUEST_TYPE,
  RequestValueKeys.AFTER_CARE_DETAILS,
  RequestValueKeys.FOLLOW_UP_PRESCRIPTION,
  RequestValueKeys.GENERAL_INQUIRY_DETAILS,
  RequestValueKeys.REFERRAL_REASON,
  RequestValueKeys.DOCUMENTS_DELIVERY,
  RequestValueKeys.CHECK_UP_DETAILS,
  RequestValueKeys.ADDITIONAL_COMMENT,
  RequestValueKeys.FILES,
  RequestValueKeys.PHONE_TRANSCRIPT,
  RequestValueKeys.CALL,
  RequestValueKeys.PHONE_AUDIO_RECORDING_URL,
  RequestValueKeys.DOCUMENTS,
  RequestValueKeys.MESSAGE,
];

const InquiryDetails = ({
  inquiry,
  onFetchAudioSource = () => {},
  onOpenFile = () => {},
  onDownloadFile = () => {},
  onWriteExamination = null,
  isPatient = true,
  showFileActions = false,
  className = '',
}) => {
  const cn = classNames('divide-y *:py-3', className);

  const filteredKeys = INQUIRY_VALUE_ORDER.filter(key => {
    if (inquiry[key] === undefined || inquiry[key] === null) return false;

    if (key === RequestValueKeys.APPOINTMENT_AVAILABILITY)
      return Object.values(inquiry[key]).some(times => times.length > 0);

    return true;
  });

  return (
    <div className={cn}>
      {filteredKeys.map(key => (
        <InquiryValue
          requestId={inquiry.id}
          key={key}
          valueKey={key}
          value={inquiry[key]}
          source={inquiry.source}
          onFetchAudioSource={onFetchAudioSource}
          onOpenFile={onOpenFile}
          onDownloadFile={onDownloadFile}
          onWriteExamination={onWriteExamination}
          isPatient={isPatient}
          showFileActions={showFileActions}
        />
      ))}
    </div>
  );
};

InquiryDetails.propTypes = {
  inquiry: InquiryPropType.isRequired,
  onFetchAudioSource: PropTypes.func,
  onOpenFile: PropTypes.func,
  onDownloadFile: PropTypes.func,
  onWriteExamination: PropTypes.func,
  isPatient: PropTypes.bool,
  showFileActions: PropTypes.bool,
  className: PropTypes.string,
};

export default InquiryDetails;
